'use strict'

/**
 * Версия ПО
 */
import * as types from '@/store/types'

const state = {
  version: null
}

const mutations = {
  [types.INFO.version.set]: (state, value) => {
    state.version = value
  }
}

const actions = {
  [types.INFO.version.set] (context, value) {
    context.commit(types.INFO.version.set, value)
  }
}

export default {
  state,
  mutations,
  actions
}
